document.addEventListener("DOMContentLoaded", () => {
  const dataEl = document.getElementById('bundleItemData');
  const productSection = document.querySelector('.product-bundle-section');
  const bundleAdd = document.querySelector('[data-bundle-add-to-cart]');
  if (!dataEl || !productSection || !bundleAdd) return;

  const bundles = JSON.parse(dataEl.innerHTML);
  const discountPercent = parseFloat(productSection.dataset.discount || '0') || 0;
  const productUrl = productSection.dataset.productUrl;
  const productTitle = productSection.dataset.productTitle;
  let mainImageSrc = productSection.dataset.imageUrl;

  // Color -> image map built in Liquid (variant image, #color_ alt text, or child product image)
  let colorImages = {};
  try {
    const colorImagesEl = productSection.querySelector('[data-bundle-color-images]');
    colorImages = JSON.parse(colorImagesEl ? colorImagesEl.textContent : '{}');
  } catch (e) {}

  function getColorImage(color) {
    const c = (color || '').trim().toLowerCase();
    const key = Object.keys(colorImages).find((k) => k.toLowerCase() === c);
    return key ? colorImages[key] : '';
  }

  let variants = [];
  let currentColor = null;
  let colorLabel = '';

  const checked = document.querySelector('input.variant__input--color-swatch:checked');
  if (checked) {
    currentColor = checked.value.toLowerCase();
    colorLabel = checked.value;
    mainImageSrc = getColorImage(colorLabel) || mainImageSrc;
  }

  function buildVariants(color) {
    variants = [];
    bundles.forEach((bundle) => {
      bundle.variants.forEach((v) => {
        if ((v.option1 || '').toLowerCase() === color) variants.push(v);
      });
    });
  }

  if (currentColor) buildVariants(currentColor);

  bundleAdd.addEventListener('click', () => addProducts());

  document.addEventListener('variant:change', (e) => {
    const selectedColor = (e.detail.value || '').toLowerCase();
    colorLabel = e.detail.value || '';
    if (e.detail.variant && e.detail.variant.featured_image) {
      mainImageSrc = e.detail.variant.featured_image.src;
    } else {
      mainImageSrc = getColorImage(colorLabel) || mainImageSrc;
    }
    buildVariants(selectedColor);

    let price = 0;
    let availability = true;
    variants.forEach((v) => {
      price += v.price;
      if (v.available === false) availability = false;
    });

    // Every child product must exist in this color, otherwise the
    // discount function won't match and checkout price would differ.
    if (variants.length !== bundles.length) availability = false;

    const discountedPrice = price * (100 - discountPercent) / 100;
    const priceEl = document.querySelector('.product-block--price .product__price');
    const compareEl = document.querySelector('.product-block--price .bundle-original_price');
    if (priceEl) priceEl.innerHTML = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
    if (compareEl) compareEl.innerHTML = theme.Currency.formatMoney(price, theme.settings.moneyFormat);

    const txt = bundleAdd.querySelector('[data-add-to-cart-text]');
    bundleAdd.disabled = !availability;
    if (txt) txt.innerHTML = availability ? 'Add to cart' : 'Sold Out';
  });

  function addProducts() {
    if (!variants.length || variants.length !== bundles.length) {
      console.warn('Bundle: not every child product has the selected color');
      return;
    }

    const qtyEl = productSection.querySelector('.js-qty__num');
    const qty = Math.max(1, parseInt(qtyEl ? qtyEl.value : 1, 10) || 1);

    let uniqueBundleId = productUrl + '---' + Date.now();
    const bundleItemsList = [];
    const includesText = [];

    variants.forEach((v) => {
      uniqueBundleId += '---' + v.id;
      bundleItemsList.push({
        title: v.name,
        image: v.featured_image ? v.featured_image.src : '',
        id: v.id,
        sku: v.sku || ''
      });
      includesText.push(v.name + (v.sku ? ' (SKU: ' + v.sku + ')' : ''));
    });

    const items = variants.map((v) => ({
      id: v.id,
      quantity: qty,
      properties: {
        // Hidden from customer, visible in Shopify admin order page
        '_Bundle': productTitle + (colorLabel ? ' - ' + colorLabel : ''),
        '_Bundle Items': includesText.join(' | '),
        '_Bundle Discount': discountPercent + '% off',
        // Internal (cart drawer)
        _bundle_id: uniqueBundleId,
        _bundle_parentId: variants[0].id,
        _bundle_url: productUrl,
        _bundle_title: productTitle,
        _bundle_image: getColorImage(colorLabel) || mainImageSrc,
        _bundle_items: bundleItemsList,
        _bundle_nick: productSection.dataset.productHandle || 'bundle',
        _bundle_discount: String(discountPercent)
      }
    }));

    bundleAdd.disabled = true;

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => res.json())
      .then((data) => {
        if (data.status === 422) {
          console.warn(data.description || data);
          return;
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: bundleAdd }
        }));
      })
      .catch(err => console.error(err))
      .finally(() => { bundleAdd.disabled = false; });
  }

  window.addProducts = addProducts;
});